import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import useDowngradeSuperAdmin from './hooks/useDowngradeSuperAdmin';

const DowngradeSuperAdminModal: React.FC<DowngradeSuperAdminProps> = ({ user, closeModal }) => {
    const { downgradeUser, isPosting, error, downgradeSuccess } = useDowngradeSuperAdmin(user.id);
    const prevSuccess = usePrevious(downgradeSuccess);

    useEffect(() => {
        if (!prevSuccess && downgradeSuccess) closeModal();
    }, [downgradeSuccess, prevSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Downgrade super admin"
            description={`Are you sure you want to downgrade '${user.firstName} ${user.lastName}' to Admin?`}
            closeModal={closeModal}
            handleSubmit={downgradeUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DowngradeSuperAdminProps {
    user: SuperAdminUser;
    closeModal: () => void;
}

export default DowngradeSuperAdminModal;
